import LivabilityMapContent from './LivabilityMapContent'

export { default as LivabilityMapContent } from './LivabilityMapContent'

export const LivabilityMapConfig = {
  Content: LivabilityMapContent,
}
